import React from "react";
// import logo from "./logo.svg";
import "./App.css";
import MainTable, { Toolbar } from "./component/table";
import { DataPlayground } from "./component/LogTable/TableSandbox";
import "bootstrap/dist/css/bootstrap.min.css";
import { Footer } from "./component/footer";
import { observer } from "mobx-react";
import { tournamentStore } from "./Store/store";
import LogoWhite from "./assets/ONLY RYAN FULL LOGO RED.png";
import {
  BrowserRouter,
  // createBrowserRouter,
  Route,
  Routes,
  // useParams,
} from "react-router-dom";
import { Overview } from "./component/overview";
import path from "path";
import PrivacyPolicy from "./component/FinePrint/privacyPolicy";
import TermsOfUse from "./component/FinePrint/termsOfUser";
import Cancellation from "./component/Account/cancellation";

function _App() {
  if (tournamentStore.loadingTournaments) {
    return (
      <div
        style={{
          display: "flex",
          flexFlow: "column",
          height: "100vh",
          width: "100vw",
          background: "black",
          color: "whitesmoke",
          justifyContent: "center",
        }}
      >
        <img
          src={LogoWhite}
          width={150}
          style={{ margin: "auto auto" }}
          alt="Standing Log by WallOf logo"
        />
      </div>
    );
  }
  return (
    <div className="App">
      <BrowserRouter>
        {/* <Toolbar /> */}
        <Routes>
          <Route element={<Overview />} path="/" />
          <Route element={<DataPlayground />} path="/_t/:tournamentID" />
          <Route element={<PrivacyPolicy />} path="/pp" />
          <Route element={<TermsOfUse />} path="/tou" />
          <Route element={<Cancellation />} path="/cancellation" />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

const App = observer(_App);

export default App;
